import { App, getCurrentInstance } from 'vue'

import { getSafeJSONValue } from '@app/utils/local-storage'

const FLASH_CLASS_NAME = 'vue-devtools-flash-updates-flash'
const FEATURE_AVAILABILITY_KEY = '__VUE_DEVTOOLS_FLASH_UPDATES_ENABLED__'

const animationCss = `
/* this might cause an issue depending on situations. needs to be implemented with better solutions.*/
.${FLASH_CLASS_NAME} {
  position: relative;
}
.${FLASH_CLASS_NAME}::before {
  animation: 1s ${FLASH_CLASS_NAME} linear forwards;
  box-sizing: border-box;

  content: '';
  pointer-events: none;
  position: absolute;
  display: block;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 9999;
}

@keyframes ${FLASH_CLASS_NAME} {
  0% {
    border: 3px solid rgb(55, 175, 169, 1);
  }
  100% {
    border: 3px solid rgba(55, 175, 169, 0);
  }
}
`

function initialize(): void {
  const style = document.createElement('style')
  style.innerHTML = animationCss
  document.head.appendChild(style)
}

function checkAvailability(): boolean {
  return !!getSafeJSONValue(FEATURE_AVAILABILITY_KEY)
}

interface VuePlugin {
  install(app: App): void
}

export const HighlightUpdatesPlugin: VuePlugin = {
  install(app) {
    initialize()
    const available = checkAvailability()
    app.mixin({
      updated: function () {
        if (!available) return

        const instance = getCurrentInstance()
        const element = instance?.proxy?.$el as HTMLElement

        if (element && element.classList) {
          if (element.classList.contains(FLASH_CLASS_NAME)) {
            element.classList.remove(FLASH_CLASS_NAME)
          }
          void element.offsetWidth
          element.classList.add(FLASH_CLASS_NAME)
        }
      },
    })
  },
}
